import type { ReactNode } from "react"

export type SceneControlIconName = "video" | "stop" | "save" | "camera" | "up" | "down"

const CAMERA_OUTLINE =
  "M5 7h1a2 2 0 0 0 2-2 1 1 0 0 1 1-1h6a1 1 0 0 1 1 1 " +
  "2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z"

const PATHS: Record<SceneControlIconName, ReactNode> = {
  video: (
    <>
      <rect x="3" y="6" width="12" height="12" rx="2" />
      <path d="M15 10l5-3v10l-5-3z" />
    </>
  ),
  stop: <rect x="6" y="6" width="12" height="12" rx="2" />,
  save: (
    <>
      <path d="M6 4h10l4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
      <path d="M8 4v4h6V4" />
      <circle cx="12" cy="14" r="2" />
    </>
  ),
  camera: (
    <>
      <path d={CAMERA_OUTLINE} />
      <circle cx="12" cy="13" r="3" />
    </>
  ),
  up: <path d="M6 15l6-6 6 6" />,
  down: <path d="M6 9l6 6 6-6" />,
}

export function SceneControlIcon({
  name,
  size,
  strokeWidth = 2,
}: {
  name: SceneControlIconName
  size: number
  strokeWidth?: number
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="block shrink-0"
      aria-hidden
    >
      {PATHS[name]}
    </svg>
  )
}
